<template>
  <div v-if="book" class="edit-book container">
    <h2 class="center-align red-text text-lighten-2">Edit {{ book.title }}</h2>
    <form @submit.prevent="editBook">
      <div class="field title">
        <label for="title">Title</label>
        <input type="text" id="title" v-model="book.title">
      </div>
      <div class="field author">
        <label for="author">Author</label>
        <input type="text" id="author" v-model="book.author">
      </div>
      <div class="field pages">
        <label for="pages">Number of Pages</label>
        <input type="text" id="pages" v-model="book.pages">
      </div>
      <div class="field genre">
        <label for="genre">Genre</label>
        <input type="text" id="genre" v-model="book.genre">
      </div>
      <div class="field center-align">
        <button class="btn red lighten-2 waves-effect waves-light">Update book</button>
      </div>
    </form>
  </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'

export default {
  name: 'EditBook',
  data() {
    return {
      book: [],
      feedback: null
    }
  },
  methods: {
    editBook() {
      if(this.book.title) {
        this.feebdack = null
        // create slug
        this.book.slug = slugify(this.book.title, {
          replacement: '-',
          remove: /[$*_+~.()'"!\-:@]/g, // remove all those from the slug
          lower: true
        })
        db.collection('books').doc(this.book.id).update({
          title: this.book.title,
          author: this.book.author,
          pages: this.book.pages,
          genre: this.book.genre,
          slug: this.book.slug
        }).then(() => {
          this.$router.push({ name: 'Reading' })
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.feedback = "You must enter a book title"
      }
    }
  },
  created() {
    let ref = db.collection('books').where('slug', '==', this.$route.params.book_slug)
    ref.get().then(snapshot => {
      snapshot.forEach(doc => {
        this.book = doc.data()
        this.book.id = doc.id
      })
    })
  }
}
</script>

<style scoped>
.edit-book {
  margin-top: 60px;
  padding: 20px;
  max-width: 500px;
}

.edit-book h2 {
  font-size: 2em;
  margin: 20px auto;
}

.edit .field {
  margin: 20px auto;
}
</style>
